import Pagination from '@/components/pagination/index.vue';
import Service from '../service-service';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      cropList: [],
      serviceScore: [],
      serviceArea: [],
      serviceProject: [],
      serviceRegion: [],
      total: 0,
      queryName: {},
      query: {
        skip: 0,
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        areaCode: ''
      },
      activeType: '',
      list: [],
      tId: '66aaf784247b9fffdb5eba0b'
    };
  },

  created() {
    this.activeType = this.$route.query.type;
    this.getList();
    this.getTypeList();
  },

  watch: {
    $route(newRoute) {
      if (newRoute) {
        this.activeType = newRoute.query.type;
        this.resetQuery();
        this.getList();
        this.getTypeList();
      }
    }
  },
  methods: {
    getList(page) {
      if (page) {
        this.query.skip = (page.pageNo - 1) * 10;
        this.query.limit = 10;
      } else {
        this.query.skip = '0';
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      if (this.activeType === '001') {
        this.getTuoguanList(obj);
      }
    },

    getOtherList() {
      // Service.getOtherServiceList({ tId: this.tId, ...obj, code: this.activeType}).then(res => {
      //   this.list = res;
      //   this.total = res.length;
      // });
    },

    getTuoguanList(obj) {
      Service.getServiceProductList({ tId: this.tId, ...obj }).then(res => {
        res.result.forEach(item => {
          item.areaListDesc = item.areaListDesc.replace(/广西壮族自治区百色市/g, '');
        });
        this.list = res.result;
        this.total = res.total;
      });
    },

    resetQuery() {
      this.query = {
        skip: 0,
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        areaCode: ''
      };
      this.queryName = {};
      this.getList();
    },

    delquery(key, value) {
      this.query[value] = '';
      this.queryName[value] = '';
      this.getList();
    },

    getTypeList() {
      if (this.activeType === '001') {
        Service.getServiceCropList({ tId: this.tId }).then(res => {

          this.cropList = res;

        });
      }
      Service.getServiceScoreLevelList().then(res => {
        this.serviceScore = res;
      });
      Service.getServiceAreaLevelList().then(res => {
        this.serviceArea = res;
      });
      Service.getAreaList({ current: '451022', level: 3 }).then(res => {
        const result = res.result.filter(item => item.id && item.id !== '150721402');
        this.serviceRegion = result;
      });
    },

    updateQueryParmas(type, item) {
      this.query[type] = item.type || item.id || item._id;
      this.queryName[type] = item.name;
      this.getList();
    },

    getTableListBySort(type) {
      if (this.query.sortBy !== type) {
        this.query.sort = 1;
      } else {
        this.query.sort = this.query.sort === 1 ? -1 : 1;
      }
      this.query.sortBy = type;
      this.getList();
    },

    toDetail(item) {
      this.$router.push('/socialized-service/service/detail?id=' + item._id + '&partnerId=' + item.partnerId);
    },
    toOther(url) {
      // console.log(url);
      this.$router.push(url);
    }
  }
};
